import {Button, Input, Select, Space, Tag} from "antd";
import {useState} from "react";

const AccountAdvancedInfo = ({}) => {
    const language = [
        {
            label: 'English',
            value: 'en',
            emoji: '🇬🇧',
        },
        {
            label: 'Korean',
            value: 'kr',
            emoji: '🇰🇷',
        },
    ]
    const [tags, setTags] = useState(["AAAA", "BBBB", "CCCC"]);
    const [inputValue, setInputValue] = useState("");

    const handleAddTag = () => {
        if (inputValue && !tags.includes(inputValue)) {
            setTags([...tags, inputValue]);
            setInputValue("");
        }
    };

    const handleRemoveTag = (removedTag) => {
        setTags(tags.filter(tag => tag !== removedTag));
    };

    return (
        <div className={"p-4 w-full"}>
            <h2 className={"font-semibold text-2xl mb-4"}>Thông tin học vấn</h2>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
                <div>
                    <label className="block text-sm font-medium text-gray-600">Trình độ</label>
                    <Input placeholder={"Nhập trình độ"}/>
                </div>
                <div>
                    <label className="block text-sm font-medium text-gray-600">Bằng cấp</label>
                    <Input placeholder={"Nhập bằng cấp"}/>
                </div>
                <div>
                    <label className="block text-sm font-medium text-gray-600">Ngoại ngữ</label>
                    <Select
                        className={"w-full"}
                        showSearch
                        mode={"multiple"}
                        placeholder={"Chọn ngoại ngữ"}
                        options={language}
                        optionRender={(language) => (
                            <Space>
                                <span role={"img"} aria-label={language.data.label}>{language.data.emoji}</span>
                                {language.data.label}
                            </Space>
                        )}
                    />
                </div>
                <div>
                    <label className="block text-sm font-medium text-gray-600">Kinh nghiệm</label>
                    <Input placeholder={"Nhập kinh nghiệm của bạn"}/>
                </div>
                <div>
                    <label className={"block text-sm font-medium text-gray-600"}>Kĩ năng mềm</label>
                    <div className="flex items-center mb-2 gap-2">
                        <Input
                            value={inputValue}
                            onChange={(e) => setInputValue(e.target.value)}
                            onPressEnter={handleAddTag}
                            placeholder={"Nhập kĩ năng mềm"}
                            className={"mr-2"}
                        />
                        <Button onClick={handleAddTag}>Thêm</Button>
                    </div>
                    {tags.map((tag, index) => (
                        <Tag
                            key={index}
                            className={"text-sm mb-2 font-medium text-gray-600"}
                            color={"blue"}
                            closable
                            onClose={() => handleRemoveTag(tag)}>
                            {tag}
                        </Tag>
                    ))}
                </div>
            </div>
        </div>
    )
}

export default AccountAdvancedInfo;